var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('Icons'),_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app__credits"},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"https://mwd.digital","target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/images/mwd.png"),"alt":""}})])])
}]

export { render, staticRenderFns }